/** SEO-friendly public detail URLs (slug preferred, numeric id as fallback). */

export function rentalDetailPath(rentalOrSlug) {
  if (rentalOrSlug == null) return '/rentals';
  if (typeof rentalOrSlug === 'object') {
    return `/rentals/${rentalOrSlug.slug || rentalOrSlug.id}`;
  }
  return `/rentals/${rentalOrSlug}`;
}

export function roommateDetailPath(roommateOrSlug) {
  if (roommateOrSlug == null) return '/roommates';
  if (typeof roommateOrSlug === 'object') {
    return `/roommates/${roommateOrSlug.slug || roommateOrSlug.id}`;
  }
  return `/roommates/${roommateOrSlug}`;
}
